import resources from './resources';

const i18nConfig = {
  resources: resources,
};

export default i18nConfig;
